import * as React from 'react';

const Tick = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='22'
    height='16'
    viewBox='0 0 22 16'
    fill='none'
    {...props}
  >
    <path
      d='M7.73377 12.2L19.0338 0.9C19.3004 0.633333 19.6171 0.5 19.9838 0.5C20.3504 0.5 20.6671 0.633333 20.9338 0.9C21.2004 1.16667 21.3338 1.48333 21.3338 1.85C21.3338 2.21667 21.2004 2.53333 20.9338 2.8L8.66711 15.0667C8.40044 15.3333 8.08933 15.4667 7.73377 15.4667C7.37822 15.4667 7.06711 15.3333 6.80044 15.0667L1.06711 9.33333C0.800439 9.06667 0.672661 8.75 0.683772 8.38333C0.694883 8.01667 0.833772 7.7 1.10044 7.43333C1.36711 7.16667 1.68377 7.03333 2.05044 7.03333C2.41711 7.03333 2.73377 7.16667 3.00044 7.43333L7.73377 12.2Z'
      fill='#F4F2F2'
    />
  </svg>
);

export default Tick;
